import { Routes } from '@angular/router';
import { Home2Component } from './home2/home2.component';
import { HomeComponent } from './home/home.component';
import { AuthGuard } from './Shared/Ui/landig/layout/auth.guard';
import { DJComponent } from '../app/Shared/Ui/landig/dj/dj.component';
export const routes: Routes = [
  {path: 'djnr',component:DJComponent},
  {
    path: '',
    loadComponent: () =>
      import('./Shared/Ui/landig/layout/layout.component').then(
        (m) => m.LayoutComponent
      ),
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: 'auth', loadChildren: () => import('./Auth/Auth.routes') },
      { path: 'home', component: Home2Component },
      { path: 'home2', component: HomeComponent },


    ],
  },

  {
    path: 'safyc',
    loadChildren: () => import('./safyc/safyc.routes'),
    canActivate: [AuthGuard]
  },
  {
    path: 'administracionusuarios',
    loadChildren: () => import('./Auth/administracionusuarios/AdministracionUsuarios.routes'),
    canActivate: [AuthGuard]
  },
  {
    path: 'administracionempresas',
    loadChildren: () => import('./Auth/administracionempresas/AdministracionEmpresas.routes'),
    canActivate: [AuthGuard]
  },
  {
    path: 'administracionconvenios',
    loadChildren: () => import('./Auth/administracionconvenios/AdministracionConvenios.routes'),
    canActivate: [AuthGuard]
  },
];
